import React, { useEffect } from "react";
import AOS from "aos";
import styles from "../styles/WhatWeDoHome.module.css";
import { Link } from "react-router-dom";

const services = [
  {
    title: "Strategic Content Marketing",
    description:
      "We specialize in crafting bespoke content marketing campaigns that help your business grow.",
    icon: "bi bi-pencil",
    wwdBgImage: "/assets/service-bg1.jpg",
  },
  {
    title: "Market Intelligence",
    description:
      "Our extensive network of experts offer competitive insights into Asia’s asset management industry.",
    icon: "bi bi-film",
    wwdBgImage: "/assets/service-bg2.jpg",
  },
  {
    title: "Media and Client Liaison",
    description:
      "Our public relations specialists help you stay in journalists’ good books and keep your clients informed.",
    icon: "bi bi-phone",
    wwdBgImage: "/assets/service-bg3.jpg",
  },
  {
    title: "Search Engine Optimisation",
    description:
      "We drive visibility with SEO strategies enhanced for AI and generative platforms.",
    icon: "bi bi-bar-chart",
    wwdBgImage: "/assets/service-bg4.jpg",
  },
  {
    title: "ORM & Social Media Marketing",
    description: "We manage your online reputation and amplify your presence.",
    icon: "bi bi-boxes",
    wwdBgImage: "/assets/service-bg5.jpg",
  },
  {
    title: "Website & Mobile App Development",
    description:
      "We design and build responsive websites and mobile apps.",
    icon: "bi bi-play",
    wwdBgImage: "/assets/service-bg6.jpg",
  },
];

const WhatWeDoHome = () => {
  useEffect(() => {
    AOS.init({ duration: 1200, once: true });
  }, []);

  return (
    <section id="wwd-what-we-do" className={styles["wwd-section"]}>
      <div className="container">
        {/* Section Header */}
        <div className="section-header text-center">
          <h2 className="section-title" data-aos="fade-up">
            Our <span>Expertise</span>
          </h2>

          <div
            className="section-subtitle mx-auto"
            data-aos="fade-up"
            data-aos-delay="150"
          >
            <h3 className="section-sub-heading">
              Expert-led solutions tailored to your goals
            </h3>

            <p className="section-description">
              We deliver a diverse portfolio of strategic and digital services,
              helping businesses shape their presence, engage their audience and
              drive meaningful growth. Every solution is tailored with clarity,
              creativity and commercial impact in mind.
            </p>
          </div>
        </div>

        {/* Services */}
        <div className="row g-4">
          {services.map((service, index) => (
            <div
              className="col-12 col-md-6 col-lg-4 d-flex"
              data-aos="zoom-in"
              data-aos-delay={100 * (index + 1)}
              key={service.title}
            >
              <div
                className={`card-8i hover-lift ${styles["wwd-icon-box"]}`}
                style={{ backgroundImage: `url(${service.wwdBgImage})` }}
              >
                <div className={styles["wwd-icon"]}>
                  <i className={service.icon} />
                </div>

                <h4 className="box-title">{service.title}</h4>
                <h6 className="box-description">{service.description}</h6>


              </div>
            </div>
          ))}
        </div>

        <br/>

        {/* CTA */}
        <div className="section-cta text-center" data-aos="fade-up">
          <Link to="/what-we-do" className="btn-primary-8i">
            Learn More →
          </Link>
        </div>
      </div>
    </section>
  );
};

export default WhatWeDoHome;
